import { useLocation } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { proposeGuide, Guide } from "@/api/guides";
import { getModuleFromPathname } from "@/lib/guide-module-map";

export const useModuleGuide = () => {
  const location = useLocation();
  const module = getModuleFromPathname(location.pathname);

  const { data, isLoading } = useQuery({
    queryKey: ["guide-propose", module],
    queryFn: () => proposeGuide(module!),
    enabled: !!module,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const guide: Guide | null = data?.guide ?? null;
  return { guide, isLoading };
};
